// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tooltip-ancho .tooltip-inner {
  max-width: 500px !important;
  text-align: left !important;
  width: max-content;
  white-space: pre-line;
  word-break: break-word;
}
.table-rows-clamped {
  table-layout: fixed;
  width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}
.modal-label-col {
  width: 200px;
  white-space: nowrap;
  vertical-align: top;
}
.incident-detail-table {
  table-layout: fixed;
  width: 100%;
}
.incident-detail-table td {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/CuadroMandoRed.vue"],"names":[],"mappings":";AA4aA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":["\n.tooltip-ancho .tooltip-inner {\n  max-width: 500px !important;\n  text-align: left !important;\n  width: max-content;\n  white-space: pre-line;\n  word-break: break-word;\n}\n\n.table-rows-clamped {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.modal-label-col {\n  width: 200px;\n  white-space: nowrap;\n  vertical-align: top;\n}\n\n.incident-detail-table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.incident-detail-table td {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
